<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/ebrochure",
		    "name": "E-Brochure"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>E-Brochure</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6 col-sm-12 text-sm-center order-md-first">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/ebrochure/runtime_security.webp" class="og_image_url"
                            alt="Secure Your Mobile Devices with our Mobile App Security Solution">
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-sm-center">
                <div class="agency-benefits">
                    <div class="content">
                        <div>
                            <h2>App<span class="redtext">Protectt</span></h2>
                        </div>
                        <p>Enhance your Mobile App Security effortlessly. It is now important, more than ever before, to secure mobile apps on an always-on, run-time basis.  AppProtectt, a state-of-the-art RASP solution, powered by Artificial Intelligence and Behavioural Science on our innovative Security Cloud. It is lightweight and easy to integrate SDK for iOS and Android d Apps.</p>
                        <p>AppProtectt comply with RBI Digital Payment Security Control Guidelines for Mobile Banking Apps. Also it includes advance device binding, unsecured Wi-Fi security check, anti-screen mirroring and sharing, anti-malware, MiTM Prevention, prevent tampering and reverse engineering and protect data at rest and motion.</p>
                        <a class="btn-rectangle btn-transparent btn text-white" data-toggle="modal"
                            data-target="#modalContactForm" (click)="brochurecount('appprotectt')">Request Brochure</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6 col-sm-12 text-sm-center d-block d-md-none">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/ebrochure/transaction_security.webp"
                            alt="Get Anti-App cloning feature ">
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-sm-center">
                <div class="agency-benefits">
                    <div class="content">
                        <div class="mt-2">
                            <h2>Protectt.<span class="redtext">ai</span> Corporate Brochure</h2>
                        </div>
                        <p>Your trusted partner in Mobile Threat Defense. Get best-in-class Mobile App, Device and Transaction Security Solutions.</p>
                        <p>Protectt.ai enables you to deploy a robust Mobile Security Framework on a cloud-based model that empowers you with greater agility, faster go-to-market, scalable & easy deployment. Our mission is to provide a Comprehensive Mobile App, Device and Transaction Security that empowers you to deliver highly secured and enhanced user experience.</p>
                        <a class="btn-rectangle btn-transparent btn text-white" data-toggle="modal"
                            data-target="#modalContactForm" (click)="brochurecount('protectt.aicorporatebrochure')">Request Brochure</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-sm-center d-none d-md-block">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/ebrochure/transaction_security.webp"
                            alt="Get Anti-App cloning feature ">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->

<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div style="background: #163e6f" class="p-2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                    #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    E-Brochure
                </h4>
            </div>
            <div class="modal-body mx-3">
                <form [formGroup]="demoForm" class="contactusform">
                    <div class="row">

                        <input type="hidden" class="form-control validate input" formControlName="ebroucherproduct"
                            name="ebroucherproduct">

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
                            <input type="text" placeholder="Enter Your Name" id="form34"
                                class="form-control validate input" formControlName="name" name="name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
                            <input type="email" placeholder="Enter Your Email " formControlName="email"
                                class="form-control input" id="email" name="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                Number*</label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                class="form-control validate input" formControlName="phonenumber" name="phonenumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.phonenumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.phonenumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.phonenumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.phonenumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34"
                                class="form-control validate input" formControlName="company" name="company"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.company.errors.required">* This field is required</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right"
                                for="form34">Designation*</label>
                            <input type="text" placeholder="Enter Your Designation" id="form34"
                                class="form-control validate input" formControlName="designation" name="designation"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-center">
                        <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Download</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>